import cmsComponentApiFactory from '../../modules/cmsComponent/cmsComponentApi'

/* Utils */
import {generateDefaultAsyncSaga, generateDefaultAsyncWatcher} from '../core/reduxUtils'

/* Actions */
import {getCmsComponentActionCreators, getDeliveryTooltipsActionCreators} from '../actions/cmsComponentActions'

function cmsComponentSagasFactory({storefrontApiClient}) {
  const cmsPageComponentApi = cmsComponentApiFactory(storefrontApiClient)

  const getCmsComponentSagas = generateDefaultAsyncSaga(
    cmsPageComponentApi.getCmsComponent,
    getCmsComponentActionCreators,
    payload => [
      payload.cmsComponents
    ]
  )

  const getDeliveryTooltipSagas = generateDefaultAsyncSaga(
    cmsPageComponentApi.getDeliveryTooltips,
    getDeliveryTooltipsActionCreators,
    payload => [
      payload.params
    ]
  )

  const watchGetCmsComponent = generateDefaultAsyncWatcher(
    'GET_CMS_COMPONENT',
    getCmsComponentSagas,
  )

  const watchGetDeliveryTooltip = generateDefaultAsyncWatcher(
    'GET_DELIVERY_TOOLTIPS',
    getDeliveryTooltipSagas,
  )

  const cmsComponentSagas = [
    watchGetCmsComponent(),
    watchGetDeliveryTooltip()
  ]

  return cmsComponentSagas
}

export default cmsComponentSagasFactory
